var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-card",
    { attrs: { bordered: false } },
    [
      _c(
        "div",
        { staticClass: "table-page-search-wrapper" },
        [
          _c(
            "a-form",
            {
              attrs: { layout: "inline" },
              nativeOn: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.searchQuery.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "a-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "a-col",
                    { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "活动范围" } },
                        [
                          _c("j-select-multiple", {
                            attrs: {
                              placeholder: "请选择",
                              options: _vm.activityCalendarScopeOptions,
                            },
                            model: {
                              value: _vm.queryParam.gradeId,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParam, "gradeId", $$v)
                              },
                              expression: "queryParam.gradeId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "活动状态" } },
                        [
                          _c("j-dict-select-tag", {
                            attrs: {
                              placeholder: "请选择",
                              dictCode: "publish_status",
                            },
                            model: {
                              value: _vm.queryParam.publishStatus,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParam, "publishStatus", $$v)
                              },
                              expression: "queryParam.publishStatus",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "活动时间" } },
                        [
                          _c("a-range-picker", {
                            style: { minWidth: "256px" },
                            attrs: { value: _vm.acDateRange },
                            on: { change: _vm.onRangeChange },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "活动名称" } },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入活动名称" },
                            model: {
                              value: _vm.queryParam.title,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParam, "title", $$v)
                              },
                              expression: "queryParam.title",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("a-col", { attrs: { xl: 4, lg: 7, md: 8, sm: 24 } }, [
                    _c(
                      "span",
                      {
                        staticClass: "table-page-search-submitButtons",
                        staticStyle: { float: "left", overflow: "hidden" },
                      },
                      [
                        _c(
                          "a-button",
                          {
                            attrs: { type: "primary", icon: "search" },
                            on: { click: _vm.searchQuery },
                          },
                          [_vm._v("查询")]
                        ),
                        _c(
                          "a-button",
                          {
                            staticStyle: { "margin-left": "8px" },
                            attrs: { type: "primary", icon: "reload" },
                            on: { click: _vm.searchReset },
                          },
                          [_vm._v("\n              重置\n            ")]
                        ),
                        false
                          ? _c(
                              "a",
                              {
                                staticStyle: { "margin-left": "8px" },
                                on: { click: _vm.handleToggleSearch },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.toggleSearchStatus ? "收起" : "展开"
                                    ) +
                                    "\n              "
                                ),
                                _c("a-icon", {
                                  attrs: {
                                    type: _vm.toggleSearchStatus
                                      ? "up"
                                      : "down",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table-operator" },
        [
          _c(
            "a-button",
            {
              attrs: { type: "primary", icon: "plus" },
              on: { click: _vm.handleAdd },
            },
            [_vm._v("新增")]
          ),
          false
            ? _c(
                "a-button",
                {
                  attrs: { type: "primary", icon: "download" },
                  on: {
                    click: function ($event) {
                      return _vm.handleExportXls("校园动态表")
                    },
                  },
                },
                [_vm._v("\n      导出\n    ")]
              )
            : _vm._e(),
          false
            ? _c(
                "a-upload",
                {
                  attrs: {
                    name: "file",
                    showUploadList: false,
                    multiple: false,
                    headers: _vm.tokenHeader,
                    action: _vm.importExcelUrl,
                  },
                  on: { change: _vm.handleImportExcel },
                },
                [
                  _c(
                    "a-button",
                    { attrs: { type: "primary", icon: "import" } },
                    [_vm._v("导入")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.selectedRowKeys.length > 0
            ? _c(
                "a-dropdown",
                [
                  _c(
                    "a-menu",
                    { attrs: { slot: "overlay" }, slot: "overlay" },
                    [
                      _c(
                        "a-menu-item",
                        { key: "1", on: { click: _vm.batchDel } },
                        [
                          _c("a-icon", { attrs: { type: "delete" } }),
                          _vm._v("\n          删除\n        "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-button",
                    { staticStyle: { "margin-left": "8px" } },
                    [
                      _vm._v("\n        批量操作\n        "),
                      _c("a-icon", { attrs: { type: "down" } }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "div",
            {
              staticClass: "ant-alert ant-alert-info",
              staticStyle: { "margin-bottom": "16px" },
            },
            [
              _c("i", {
                staticClass: "anticon anticon-info-circle ant-alert-icon",
              }),
              _vm._v("\n      已选择\n      "),
              _c("a", { staticStyle: { "font-weight": "600" } }, [
                _vm._v(_vm._s(_vm.selectedRowKeys.length)),
              ]),
              _vm._v("\n      项\n      "),
              _c(
                "a",
                {
                  staticStyle: { "margin-left": "24px" },
                  on: { click: _vm.onClearSelected },
                },
                [_vm._v("清空")]
              ),
            ]
          ),
          _c("a-table", {
            ref: "table",
            staticClass: "j-table-force-nowrap",
            attrs: {
              size: "middle",
              bordered: "",
              rowKey: "id",
              columns: _vm.columns,
              dataSource: _vm.dataSource,
              pagination: _vm.ipagination,
              loading: _vm.loading,
              rowSelection: {
                selectedRowKeys: _vm.selectedRowKeys,
                onChange: _vm.onSelectChange,
              },
            },
            on: { change: _vm.handleTableChange },
            scopedSlots: _vm._u([
              {
                key: "sumaryInfoSlot",
                fn: function (text, record) {
                  return [
                    _c("div", { staticClass: "sumary-info-column" }, [
                      _c("div", { attrs: { classs: "left-img" } }, [
                        _c("img", {
                          staticStyle: {
                            "max-width": "80px",
                            "font-size": "12px",
                            "font-style": "italic",
                          },
                          attrs: {
                            src: _vm.getImgView(text),
                            height: "80px",
                            alt: "",
                          },
                          on: {
                            click: function ($event) {
                              _vm.showImgDialog(_vm.getImgView(text))
                            },
                          },
                        }),
                      ]),
                      _c("div", { staticClass: "right-txt" }, [
                        _c("span", { staticClass: "title" }, [
                          _vm._v(_vm._s(record.title)),
                        ]),
                        _c("span", { staticClass: "time" }, [
                          _vm._v(
                            _vm._s(record.beginDate + " 至 " + record.endDate)
                          ),
                        ]),
                      ]),
                    ]),
                  ]
                },
              },
              {
                key: "picUrl",
                fn: function (text) {
                  return [
                    !text
                      ? _c(
                          "span",
                          {
                            staticStyle: {
                              "font-size": "12px",
                              "font-style": "italic",
                            },
                          },
                          [_vm._v("无图片")]
                        )
                      : _c("img", {
                          staticStyle: {
                            "max-width": "80px",
                            "font-size": "12px",
                            "font-style": "italic",
                          },
                          attrs: {
                            src: _vm.getImgView(text),
                            height: "80px",
                            alt: "",
                          },
                          on: {
                            click: function ($event) {
                              _vm.showImgDialog(_vm.getImgView(text))
                            },
                          },
                        }),
                  ]
                },
              },
              {
                key: "fileSlot",
                fn: function (text) {
                  return [
                    !text
                      ? _c(
                          "span",
                          {
                            staticStyle: {
                              "font-size": "12px",
                              "font-style": "italic",
                            },
                          },
                          [_vm._v("无文件")]
                        )
                      : _c(
                          "a-button",
                          {
                            attrs: {
                              ghost: true,
                              type: "primary",
                              size: "small",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.preview(text)
                              },
                            },
                          },
                          [_vm._v("\n          预览视频\n        ")]
                        ),
                  ]
                },
              },
              {
                key: "dateRangeSlot",
                fn: function (text, record) {
                  return [
                    !record.beginDate && !record.endDate
                      ? _c(
                          "span",
                          {
                            staticStyle: {
                              "font-size": "12px",
                              "font-style": "italic",
                            },
                          },
                          [_vm._v("-")]
                        )
                      : _vm._e(),
                    _c("span", [
                      _vm._v(_vm._s(record.beginDate + "到" + record.endDate)),
                    ]),
                  ]
                },
              },
              {
                key: "publishSlot",
                fn: function (text, record) {
                  return [
                    _c("a-switch", {
                      attrs: { checked: text },
                      on: {
                        change: function ($event) {
                          return _vm.changePublishStatus(record.id, text)
                        },
                      },
                    }),
                  ]
                },
              },
              {
                key: "action",
                fn: function (text, record) {
                  return _c(
                    "span",
                    {},
                    [
                      _c(
                        "a",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.handleEdit(record)
                            },
                          },
                        },
                        [_vm._v("编辑")]
                      ),
                      _c("a-divider", { attrs: { type: "vertical" } }),
                      _c(
                        "a-popconfirm",
                        {
                          attrs: { title: "确定删除吗?" },
                          on: { confirm: () => _vm.handleDelete(record.id) },
                        },
                        [_c("a", [_vm._v("删除")])]
                      ),
                    ],
                    1
                  )
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("SchoolActivityVideo", { ref: "carLocation" }),
      _c("SchoolActivityCalendarModal", {
        ref: "modalForm",
        on: { ok: _vm.modalFormOk },
      }),
      _c(
        "j-modal",
        {
          attrs: {
            title: "预览",
            width: 800,
            visible: _vm.previewVisible,
            footer: null,
            maskClosable: true,
          },
          on: { cancel: _vm.closePreview },
        },
        [
          _c("div", {
            staticStyle: { "max-height": "600px", "overflow-y": "auto" },
            domProps: { innerHTML: _vm._s(_vm.previewContent) },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }